  /*============ Content Controller
  ================================*/
  angular
      .module('vppApp')
      .controller('contentController', contentController);

    contentController.$inject = ['$scope', '$state', '$window', 'contentFactory', '$stateParams', 'vppConfig', 'ViewFinderService', 'SetLiveSwapService', 'VarientService'];

    function contentController($scope, $state, $window, contentFactory, $stateParams, vppConfig, ViewFinderService, SetLiveSwapService, VarientService){

      // This is a hacky workaround because GMIT is unable to open a new CR in time for our deploy to get this to the correct URL
      // We need to have the vanity URL go to the homepage, but the vanity URL is currently going to /promote/

      // if ($state.current.name === 'promote.main') {
      //   let varient = VarientService.getVarientName();
      //   if ($window.location.search.indexOf('vn=soty') !== -1) {
      //     $state.go('index');
      //   }
      // }

      //get Live Swap values for image
      var lsValue = SetLiveSwapService.getLSBrandName();
      if (lsValue) {
        var lsImage = vppConfig.lsImage[lsValue];
      } else {
        var lsImage = '';
      }
      contentFactory().then(function (response) {
        $scope.tile = response.data.content;
        $scope.items = $scope.tile.items;
        $scope.itemsRight = $scope.tile.itemsRight;
        $scope.title = $scope.tile.title;
        $scope.img = $scope.tile.img;
        $scope.src = ($scope.img)  ? $scope.img.src + '.png' : null;
        $scope.iAmClass = $scope.tile.iAmClass;
        $scope.iAmId = $scope.tile.iAmId;
        var liveSwap = $scope.tile.liveSwap;
        if (lsValue && liveSwap) {
          if($scope.img){
            $scope.src = $scope.img.src + lsImage + ".png";
          }
        }
      });
  };